import clsx from 'clsx'
import { FC, ReactFragment, ReactNode } from 'react'

import DefaultComponentProps from '@/types/DefaultComponentProps'

import styles from './Header.module.scss'

interface HeaderProps extends DefaultComponentProps {
  before?: ReactNode
  after?: ReactNode | ReactFragment
  children?: ReactNode
}

const Header: FC<HeaderProps> = ({
  className = '',
  before = null,
  after = null,
  children = null
}) => {
  return (
    <header id={'header'} className={clsx(styles['header'], className)}>
      <div className={styles['header__inner']}>
        {before && <div className={styles['header__side']}>{before}</div>}
        <div className={styles['header__content']}>{children}</div>
        {after && <div className={styles['header__side']}>{after}</div>}
      </div>
    </header>
  )
}

export default Header
